export default __webpack_public_path__ + "static/media/image8.65f6c289.webp";